import * as monaco from 'monaco-editor';
import {
  ProtocolConnection,
  ServerCapabilities,
} from 'vscode-languageserver-protocol';

import { OnException } from '../utils/convertVscodeToMonaco';

import { codeActionProvider } from './codeActionProvider';
import { completionProvider } from './completionProvider';
import { definitionProvider } from './definitionProvider';
import { hoverProvider } from './hoverProvider';
import { semanticTokensProvider } from './semanticTokensProvider';
import { textDocumentSync } from './textDocumentSync';

export function registerCapabilities({
  languageId,
  connection,
  capabilities,
  onException,
}: {
  languageId: string;
  connection: ProtocolConnection;
  capabilities: ServerCapabilities<unknown>;
  onException: OnException;
}) {
  let addModel = (_model: monaco.editor.ITextModel) => {};

  (Object.keys(capabilities) as Array<keyof typeof capabilities>).forEach(
    (capability: keyof typeof capabilities) => {
      switch (capability) {
        case 'completionProvider':
          completionProvider(
            languageId,
            connection,
            capabilities.completionProvider,
            onException,
          );
          break;
        case 'definitionProvider':
          definitionProvider(
            languageId,
            connection,
            capabilities.definitionProvider,
          );
          break;
        case 'hoverProvider':
          hoverProvider(languageId, connection, capabilities.hoverProvider);
          break;
        case 'semanticTokensProvider':
          semanticTokensProvider(
            languageId,
            connection,
            capabilities.semanticTokensProvider,
          );
          break;
        case 'textDocumentSync':
          addModel =
            textDocumentSync(
              languageId,
              connection,
              capabilities.textDocumentSync,
            ) ?? addModel;
          break;
        case 'codeActionProvider':
          codeActionProvider(
            languageId,
            connection,
            capabilities.codeActionProvider,
            onException,
          );
          break;
        default:
          onException(`Unhandled language server capability: ${capability}`);
      }
    },
  );

  return addModel;
}
